import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import FontFa from "../../../../../components/fontFa/fontFa";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import {
  getApproverName,
  getEmployeeDetail,
} from "../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { useSelector } from "../../../../../store/store";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";
import { RenderProgress } from "../../../human-organization/summary-employee-request/utils/render-helper";

export const RecallToolProgress: FC<{ employees: any[]; detail: any }> = ({
  employees,
  detail,
}) => {
  const { getITLeadITHeadAssignee } = useSoftwares();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const progress = [
    {
      status: detail?.fields?.eApprovedStatus,
      name:
        detail?.fields?.eApprovedName ||
        getEmployeeDetail(
          detail?.fields?.eApprovedBy?.toLowerCase(),
          employees,
          softwares
        )?.[0]?.Title,
      email: detail?.fields?.eApprovedBy?.toLowerCase(),
      approvedDate: detail?.fields?.eApprovedDate,
      title: "Thủ trưởng cơ quan đơn vị",
    },
    {
      status: detail?.fields?.eApprovedByITLeadStatus,
      name: getApproverName(
        detail?.fields?.eApprovedByITLead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITLead
      ),
      email: detail?.fields?.eApprovedByITLead,
      approvedDate: detail?.fields?.eApprovedByITLeadDate,
      title: "Bộ phận kỹ thuật",
    },

    {
      status: detail?.fields?.eApprovedByITHeadStatus,
      name: getApproverName(
        detail?.fields?.eApprovedByITHead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITHead
      ),
      email: detail?.fields?.eApprovedByITHead,
      approvedDate: detail?.fields?.eApprovedByITHeadDate,
      title: "Bộ phận hành chính phòng KHĐT",
    },

    {
      status: detail?.fields?.eAssigneeStatus,
      name: getApproverName(
        detail?.fields?.eAssignee,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.ETR).eAssignee
      ),
      email: detail?.fields?.eAssignee,
      approvedDate: detail?.fields?.eAssigneeStatusDate,
      title: "Phòng KHĐT",
    },
  ];

  return (
    <Box title="Quy trình duyệt">
      <div className="TimelineBox horizontal mdHorizontal mdSmall">
        <div className="item">
          <div className="step approved">
            <FontFa name="faCheck" />
          </div>
          <div className="content">
            <div className="rank">
              <h6>Khởi tạo</h6>
            </div>
            <div className="title">{detail?.createdBy?.user?.displayName}</div>
            <div className="title">{detail?.createdBy?.user?.email} </div>
            <div className="time">
              {`Ngày tạo: ${getDDMMYYYFormat(
                detail?.createdDateTime
              )} - ${getHHmmFormat(detail?.createdDateTime)}`}
            </div>
          </div>
        </div>

        <RenderProgress progress={progress} />
      </div>
    </Box>
  );
};
